import { Pipe, PipeTransform } from '@angular/core';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';

@Pipe({
  name: 'filterDocumentType'
})
export class FilterDocumentTypePipe implements PipeTransform {

  transform(items: TipoDocumento[], primary: boolean, doc: any): unknown {
    if(primary) {
      return items;
    } else {
      let filtered = items.filter(el => !!el.codiceAllegatoProtocollo);
      return filtered;
    }
  }

}

